import styled from 'styled-components';

const getIcon = (color) => {
  const fillColor = encodeURIComponent(color);

  return `url("data:image/svg+xml;charset=utf-8,%3Csvg fill='${fillColor}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M8.586 5.586c-.781.781-.781 2.047 0 2.828l3.585 3.586-3.585 3.586c-.781.781-.781 2.047 0 2.828.39.391.902.586 1.414.586s1.024-.195 1.414-.586l6.415-6.414-6.415-6.414c-.78-.781-2.048-.781-2.828 0z'/%3E%3C/svg%3E")`;
};

export const Container = styled.div`
  align-items: flex-end;
  justify-content: center;
  margin: auto auto 0.5rem;
  text-align: center;
`;

export const Title = styled.h2`
  font-size: 1.6rem;
  line-height: 1;
  margin-bottom: 0.5rem;
`;

export const CountryName = styled.div`
  color: var(--theme-color-text);
  font-weight: bold;
  margin-right: 0.25rem;
`;

export const CountryFlag = styled.div`
  height: 15px;
  margin-right: 0.5rem;
  width: 24px;
`;

export const EditButton = styled.button`
  align-items: center;
  background: none;
  border: 0;
  cursor: pointer;
  display: inline-flex;
  margin: 0;
  padding: 0.5rem 0.2rem 0.5rem 0.5rem;
  transition: background 100ms ease-in-out;

  &:hover {
    background: var(--theme-color-grey);
  }
`;

export const EditIcon = styled.div`
  background: none no-repeat bottom center;
  background-image: ${(props) => getIcon(props.theme.colors?.grey3)};
  background-size: 18px 18px;
  height: 20px;
  transform: rotate(90deg);
  transition: transform 100ms ease-in-out;
  width: 20px;

  ${EditButton}:hover & {
    transform: rotate(0deg);
  }
`;

export const Pixel = styled.img`
  border: 0;
  display: inline-block !important;
  height: 1px;
  width: 1px;
`;

export const Buttons = styled.div`
  padding: 0 2rem 1rem;
  text-align: center;

  @media ${(props) => props.theme.breakpoints.sm} {
    padding: 0 1rem 1rem;
  }

  @media ${(props) => props.theme.breakpoints.lg} {
    display: flex;
    justify-content: center;
    padding: 0 0.5rem 1rem;

    > * {
      margin-left: 1rem;
      max-width: 300px;
      width: 50%;

      &::first-child {
        margin-left: 0;
      }
    }
  }
`;
